import { Td, Tr } from "@chakra-ui/react";

const TBodyTemporaryLog = ({ data }) => {
  return (
    <>
      <Tr>
        <Td className="text-center"> {data?.qualified_user_nit ? data?.qualified_user_nit : "N/A"}</Td>
        <Td className="text-center"> {data?.qualified_user_name ? data?.qualified_user_name : "N/A"}</Td>
        <Td className="text-center"> {data?.decimal_values_precision ? data?.decimal_values_precision : "N/A"}</Td>
        <Td className="text-center"> {data?.operation_type ? data?.operation_type : "N/A"}</Td>
        <Td className="text-center"> {data?.form_code ? data?.form_code : "N/A"}</Td>
        <Td className="text-center"> {data?.item_code ? data?.item_code : "N/A"}</Td>

        <Td className="text-center"> {data?.authorization ? data?.authorization : "N/A"}</Td>
        <Td className="text-center"> {data?.inventory_import_declaration ? data?.inventory_import_declaration : "N/A"}</Td>
        <Td className="text-center"> {data?.input_quantity ? data?.input_quantity : "N/A"}</Td>
        <Td className="text-center"> {data?.output_quantity ? data?.output_quantity : "N/A"}</Td>

        <Td className="text-center"> {data?.input_quantity_product ? data?.input_quantity_product : "N/A"}</Td>
        <Td className="text-center"> {data?.output_quantity_product ? data?.output_quantity_product : "N/A"}</Td>
        <Td className="text-center"> {data?.business_unit_code ? data?.business_unit_code : "N/A"}</Td>
        <Td className="text-center"> {data?.business_unit_name ? data?.business_unit_name : "N/A"}</Td>

        <Td className="text-center"> {data?.product_business_unit_code ? data?.product_business_unit_code : "N/A"}</Td>
        <Td className="text-center"> {data?.product_business_unit_name ? data?.product_business_unit_name : "N/A"}</Td>

        <Td className="text-center"> {data?.inventory_net_weight_product_unit ? data?.inventory_net_weight_product_unit : "N/A"}</Td>
        <Td className="text-center"> {data?.inventory_value_fob_unit_product ? data?.inventory_value_fob_unit_product : "N/A"}</Td>
        <Td className="text-center"> {data?.inventory_value_cif_unit_product ? data?.inventory_value_cif_unit_product : "N/A"}</Td>
        <Td className="text-center"> {data?.inventory_quantity_available ? data?.inventory_quantity_available : "N/A"}</Td>

        <Td className="text-center"> {data?.inventory_quantity_available_product ? data?.inventory_quantity_available_product : "N/A"}</Td>
        <Td className="text-center"> {data?.convertion_factor_product ? data?.convertion_factor_product : "N/A"}</Td>
        <Td className="text-center"> {data?.reference_product ? data?.reference_product : "N/A"}</Td>
        <Td className="text-center"> {data?.input_value ? data?.input_value : "N/A"}</Td>

        <Td className="text-center"> {data?.output_value ? data?.output_value : "N/A"}</Td>
        <Td className="text-center"> {data?.input_weight ? data?.input_weight : "N/A"}</Td>
        <Td className="text-center"> {data?.output_weight ? data?.output_weight : "N/A"}</Td>
        <Td className="text-center"> {data?.inventory_created_at ? data?.inventory_created_at : "N/A"}</Td>
      </Tr>
    </>
  );
};

export default TBodyTemporaryLog;
